var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeylessEntry32 = function SvgKeylessEntry32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14c0-3.183 1.37-6.235 3.808-8.485C9.246 3.265 12.552 2 16 2c3.448 0 6.754 1.264 9.192 3.515C27.63 7.765 29 10.817 29 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14c0-2.122.948-4.157 2.636-5.657C11.324 6.843 13.613 6 16 6s4.676.843 6.364 2.343C24.052 9.843 25 11.878 25 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-3.663c0-1.15.421-2.253 1.172-3.067.75-.813 1.767-1.27 2.828-1.27 1.06 0 2.078.457 2.828 1.27.75.814 1.172 1.917 1.172 3.067V18m.6 0h-9.2C9.524 18 8 19.626 8 21.633v4.734C8 28.374 9.523 30 11.4 30h9.2c1.877 0 3.4-1.626 3.4-3.633v-4.734C24 19.626 22.477 18 20.6 18Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgKeylessEntry32;